import {IPartner} from "../../models/partners/partners.interface";

export interface IPartnersState {
  data: Array<IPartner>;
  isLoaded: boolean;
}
export const initialPartnersState:IPartnersState = {
  data: [],
  isLoaded: false
};
